import jsPDF from "jspdf";
import signatureImage from "../assets/signature.png";

export default function generateWelcomeLetter(member) {
  const doc = new jsPDF();
  let y = 20;

  // Header
  doc.setFont("Times", "Bold");
  doc.setFontSize(12);
  doc.text("SHINE AGRI ALLIED AND MARKETING", 105, y, { align: "center" });
  y += 6;
  doc.text("MULTISTATE COOPERATIVE SOCIETY LIMITED", 105, y, { align: "center" });

  y += 6;
  doc.setFont("Times", "Italic");
  doc.setFontSize(10);
  doc.text("(Registered under the Multi-State Cooperative Societies Act, 2002)", 105, y, { align: "center" });

  y += 6;
  doc.setFont("Times", "Normal");
  doc.setFontSize(9);
  doc.text("Head Office: 48, 1st Floor, Amar Arcade, Nilpur, Ta-Dantiwada, Dist-Banaskantha, Gujarat – 385505", 105, y, { align: "center" });

  y += 5;
  doc.text("Contact: +91 84908 84020, 93133 99225", 105, y, { align: "center" });

  y += 6;
  doc.setLineWidth(0.3);
  doc.line(20, y, 190, y);
  y += 10;

  // Title and Date
  doc.setFont("Times", "Bold");
  doc.setFontSize(11);
  doc.text("WELCOME LETTER", 105, y, { align: "center" });
  const today = new Date();
  const dateStr = `${today.getDate().toString().padStart(2, "0")}/${(today.getMonth() + 1).toString().padStart(2, "0")}/${today.getFullYear()}`;
  doc.setFontSize(9);
  doc.text(`Date: ${dateStr}`, 160, y);
  y += 10;

  // Recipient info
  doc.setFont("Times", "Bold");
  doc.text("To,", 20, y);
  y += 6;
  doc.text(`Shri/Smt. ${member.name}`, 20, y);
  y += 6;
  doc.text(`Member ID: ${member.member_id}`, 20, y);
  y += 6;
  const addressLines = doc.splitTextToSize(`Address: ${member.address}`, 160);
  doc.text(addressLines, 20, y);
  y += addressLines.length * 5;
  y += 4;

  // Subject
  doc.setFont("Times", "Bold");
  const subjectLine = "Subject: Welcome to Shine Agri Allied and Marketing Multistate Cooperative Society Ltd.";
  doc.text(subjectLine, 20, y);
  doc.line(20, y + 1, 140, y + 1);
  y += 14;

  // Body paragraph
  doc.setFont("Times", "Normal");
  const paragraph = `Dear Member,

We are delighted to welcome you as a valued member of the Shine Agri Allied and Marketing Multistate Cooperative Society Ltd. Your trust in our society strengthens our commitment to delivering transparent, cooperative, and growth-oriented services for the farming and allied communities.

• As a registered shareholder, you are now an integral part of our mission to empower agricultural stakeholders through collective strength, advanced planning, and mutual support. You are entitled to participate in the affairs of the society, attend general meetings, and avail the benefits extended to all members.

We are confident that with your active participation and support, we will grow together in the spirit of cooperation and sustainable development.

Thank you for becoming a part of the SAAM family!`;

  const bodyLines = doc.splitTextToSize(paragraph, 170);
  doc.text(bodyLines, 20, y);
  y += bodyLines.length * 4 + 5;

  // Footer
  doc.text("Warm regards,", 20, y);
  y += 15;
  doc.setFont("Times", "Bold");
  doc.text("For Shine Agri Allied and Marketing", 20, y);
  y += 6;
  doc.text("Multistate Cooperative Society Ltd.", 20, y);
  y += 6;

  doc.addImage(signatureImage, "PNG", 20, y, 50, 20);
  y += 25;

  doc.setFont("Times", "Normal");
  doc.text("Authorized Signatory", 20, y);
  y += 3;
  doc.text("(With Seal & Signature)", 20, y);

  // Save
  doc.save(`WelcomeLetter_${member.member_id}.pdf`);
}
